import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

import { AnimalFigure } from "@/components/camp/AnimalFigure";
import { campIdentityFor } from "@/components/room/campIdentity";
import { useAvatarChoice } from "@/hooks/useAvatarChoice";
import { useDisplayName } from "@/hooks/useDisplayName";
import { useYourPeerId } from "@/hooks/useYourPeerId";

/**
 * Your character on home, read-only: the figure in its colour and the name,
 * one press away from the profile, which is the only place it changes.
 */
export function CharacterCard() {
  const { t } = useTranslation();
  const peerId = useYourPeerId();
  const identity = campIdentityFor(peerId, useAvatarChoice());
  const name = useDisplayName();

  return (
    <Link
      to="/profile"
      data-testid="home-character"
      className="group flex items-center gap-3 rounded-2xl border border-border bg-card px-3 py-2 transition-colors duration-(--motion-quick) hover:border-primary/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <AnimalFigure
        data-testid="character-figure"
        data-animal={identity.animal}
        data-colour={identity.colour}
        animal={identity.animal}
        colour={identity.colour}
        className="h-16 w-12 flex-none"
      />
      <span
        data-testid="character-name"
        className="min-w-0 flex-1 truncate text-base font-semibold text-foreground"
      >
        {name || t("avatar.namePlaceholder")}
      </span>
      {/* After the name, so the link is called by what it shows. */}
      <span className="sr-only">{t("settings.openProfile")}</span>
      <ChevronRight
        aria-hidden="true"
        className="size-4 flex-none text-muted-foreground group-hover:text-foreground"
      />
    </Link>
  );
}
